<template>
  <div>
    <ShipmentDetail
      :shipmentCode="shipmentCode"
      :disabled="disabled"
      :allowUploadFile="false"
    />
  </div>
</template>
<script>
import ShipmentDetail from '@/views/factory/transport/components/shipment-detail'
export default {
  name: 'transport-shipment-detail',
  components: {
    ShipmentDetail,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    shipmentCode() {
      return this.params.code
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
